export default "__VITE_ASSET__XtDNUUb2__"